/**
 * Render order for the GPX map layers, lowest first. OpenLayers draws layers in
 * zIndex order and falls back to the order they were added for ties, so every
 * GPX layer states its place here instead of depending on construction order —
 * which is spread across MapGpx, GpxEditSession and GpxEditInteractions.
 *
 * Interaction overlays (the Draw sketch and Modify's vertex handles) are attached
 * with setMap() rather than addLayer(), so OpenLayers always renders them above
 * everything here and they don't need an entry.
 */
export const GpxLayerZIndex = {
    /** Saved route lines. */
    routes: 0,
    /** The line being edited, above the saved route it stands in for. */
    editLine: 900,
    /**
     * Start/finish markers for the line being edited. Above the edit line but below
     * the waypoints: these are read-only signposts, so they must never cover a
     * marker the user is meant to click.
     */
    editEndpoints: 950,
    /** Waypoint markers — above the edit line, so editing can't bury them. */
    waypoints: 1000,
    /**
     * Trim-mode hover preview: the stretch of route a click would remove. Above
     * the line it is previewing, below the dots so it can't swallow the click.
     */
    trimPreview: 1050,
    /** Trim-mode vertex dots: they are click targets, so nothing may cover them. */
    trimDots: 1100
} as const;
